import React from "react";
import { Alert, AlertIcon, Text, Link } from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";

import { PossibleLocations } from "@constants";
import { useGetModulesInTransitTo } from "@hooks";

type TransitModuleDisplayProps = {
  transitOrientation: "origin" | "destination";
  location: PossibleLocations;
};

export function TransitModulesDisplay({
  transitOrientation,
  location,
}: TransitModuleDisplayProps) {
  const { documents: modulesInTransitTo } = useGetModulesInTransitTo(location);
  if (modulesInTransitTo === undefined || modulesInTransitTo.length < 1)
    return null;
  const descriptionText = `The following modules have been shipped ${transitOrientation === "origin" ? "from" : "to"} ${location} and are awaiting pickup: `;
  return (
    <Alert status="info">
      <AlertIcon />
      <Text>
        {descriptionText}
        {modulesInTransitTo.map((m) => (
          <Link key={m.id} as={ReactRouterLink} to={` /modules/${m.id}`}>
            {m.id + " "}
          </Link>
        ))}
      </Text>
    </Alert>
  );
}
